const Style = {
    lede: 'm-0 text-base leading-relaxed text-text-secondary md:text-lg',
    list: 'flex flex-col gap-6',
    item: 'border-t border-border pt-5',
    title: 'mb-1.5 mt-0 text-base font-semibold text-text-primary',
    desc: 'm-0 text-sm leading-relaxed text-text-secondary',
};

export default Style;
